import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminCategories() {
    const [list, setList] = useState([]);
    const [name, setName] = useState("");
    const load = () => api.get("/categories").then((r) => setList(r.data));
    useEffect(() => { load(); }, []);

    const add = async (e) => {
        e.preventDefault();
        if (!name.trim()) return;
        await api.post("/admin/categories", { name });
        setName("");
        toast.success("Categoria criada");
        load();
    };
    const del = async (id) => {
        if (!window.confirm("Eliminar?")) return;
        await api.delete(`/admin/categories/${id}`);
        load();
    };

    return (
        <div data-testid="admin-categories-page">
            <h1 className="font-display font-black text-4xl tracking-tighter mb-6">Categorias</h1>
            <form onSubmit={add} className="flex gap-2 mb-6 max-w-md">
                <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nova categoria" className="input-edge" data-testid="cat-input" />
                <button className="btn-primary" data-testid="cat-add-btn"><Plus size={16} /> Adicionar</button>
            </form>
            <div className="border-2 border-ink bg-white">
                {list.map((c, i) => (
                    <div key={c.id} className={`flex items-center justify-between p-4 ${i < list.length - 1 ? "border-b border-ink/10" : ""}`}>
                        <div>
                            <div className="font-bold">{c.name}</div>
                            <div className="text-xs font-mono text-ink/60">/{c.slug}</div>
                        </div>
                        <button onClick={() => del(c.id)} className="text-ink/60 hover:text-destructive">
                            <Trash2 size={16} />
                        </button>
                    </div>
                ))}
                {list.length === 0 && <div className="p-8 text-center font-mono text-ink/50">Sem categorias.</div>}
            </div>
        </div>
    );
}
